import { Component } from '@angular/core';

import { TOAST_LIFE_MS } from './core/constant/toast.constant';

@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: './app.component.html',
})
export class AppComponent {
    protected readonly toastLife = TOAST_LIFE_MS;
}
